import React, { type FC } from "react";
import { Divider } from "@edreamsodigeo/prisma-design-system";

const FooterDivider: FC = () => (
  <Divider orientation="horizontal" color="neutral.40" />
);

export default FooterDivider;
